<!--
 * @Author: cmchiu
 * @Date: 2023-04-06 14:19:05
 * @LastEditTime: 2023-05-17 15:52:24
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \IACMP\IACMP_Client\src\views\contact.vue
 * 
-->
<template>
    <div class="app-contact">
        <breadcrumb />

        <div class="layer-container">
            <div class="contact-wrapper">
                <h2 class="contact-title">聯絡我們</h2>
                <p class="contact-description">請告訴我們您的需求內容，我們將立即與您聯繫！</p>

                <form class="contact-form d-flex justify-content-between flex-wrap" @submit.prevent="submitForm">
                    <div class="contact-form__item contact-form__item--short">
                        <label class="contact-form__label d-flex align-content-start" for="name">
                            姓 名
                            <img class="contact-form__star" src="images/star.svg" alt="" />
                        </label>
                        <input
                            class="contact-form__input w-100"
                            placeholder="姓 名"
                            type="text"
                            name="name"
                            id="name"
                            v-model="form.CtName"
                            required
                        />
                    </div>
                    <div class="contact-form__item contact-form__item--short">
                        <div class="contact-form__radio d-flex align-items-center">
                            <input
                                class="contact-form__radio-input"
                                type="radio"
                                id="man"
                                name="man"
                                value="M"
                                v-model="form.CtGender"
                                required
                            />
                            <label class="contact-form__radio-label" for="man">先生</label>
                            <input
                                class="contact-form__radio-input"
                                type="radio"
                                id="woman"
                                name="man"
                                value="F"
                                v-model="form.CtGender"
                                required
                            />
                            <label class="contact-form__radio-label" for="woman">女士</label>
                        </div>
                    </div>
                    <div class="contact-form__item contact-form__item--short">
                        <label class="contact-form__label d-flex align-content-start" for="phone">
                            電 話
                            <img class="contact-form__star" src="images/star.svg" alt="" />
                        </label>
                        <input
                            class="contact-form__input w-100"
                            placeholder="電 話"
                            type="text"
                            name="phone"
                            id="phone"
                            v-model="form.CtTEL"
                            required
                        />
                    </div>
                    <div class="contact-form__item contact-form__item--short">
                        <label class="contact-form__label d-flex align-content-start" for="email">
                            E-mail
                            <img class="contact-form__star" src="images/star.svg" alt="" />
                        </label>
                        <input
                            class="contact-form__input w-100"
                            placeholder="E-mail"
                            type="text"
                            name="email"
                            id="email"
                            v-model="form.CtEmail"
                            required
                        />
                    </div>
                    <div class="contact-form__item contact-form__item--short">
                        <label class="contact-form__label d-flex align-content-start" for="company">
                            公司/學校
                            <img class="contact-form__star" src="images/star.svg" alt="" />
                        </label>
                        <input
                            class="contact-form__input w-100"
                            placeholder="公司/學校名稱"
                            type="text"
                            name="company"
                            id="company"
                            v-model="form.CtCompany"
                            required
                        />
                    </div>
                    <div class="contact-form__item contact-form__item--short">
                        <label class="contact-form__label d-flex align-content-start" for="unit"> 單位 </label>
                        <input
                            class="contact-form__input w-100"
                            placeholder="公司/學校單位"
                            type="text"
                            name="unit"
                            id="unit"
                            v-model="form.CtUnit"
                        />
                    </div>
                    <div class="contact-form__item contact-form__item--long">
                        <label class="contact-form__label d-flex align-content-start" for="category">
                            洽詢類別
                            <img class="contact-form__star" src="images/star.svg" alt="" />
                        </label>
                        <select
                            class="contact-form__input contact-form__select w-100"
                            v-model="form.ConsultType"
                            required
                        >
                            <option selected disabled value="">請選擇</option>
                            <option
                                v-for="opt in consultTypeLs"
                                :key="opt.ParaValue"
                                :value="opt.ParaValue"
                                v-text="opt.ParaLabel"
                            ></option>
                        </select>
                    </div>
                    <div class="contact-form__item contact-form__item--long">
                        <label class="contact-form__label d-flex align-content-start" for="ask"> 洽詢內容 </label>
                        <textarea
                            class="contact-form__input contact-form__textarea w-100"
                            placeholder="請簡述想要洽詢的內容"
                            name="ask"
                            id="ask"
                            v-model="form.ConsultContent"
                        ></textarea>
                    </div>
                    <p class="contact-form__remind w-100">送出資料後，我們將立即與您聯繫</p>
                    <div class="contact-form__button-set">
                        <input class="contact-form__button contact-form__reset" type="reset" value="清 除" />
                        <input class="contact-form__button contact-form__submit" type="submit" value="送 出" />
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { getParaLs } from '@/api/common'
import { insertContact } from '@/api/contact'
import { breadcrumb } from '@c'

export default {
    name: 'contact',

    components: { breadcrumb },

    data() {
        return {
            configs: {
                loading: false,
            },
            consultTypeLs: [],
            form: {
                CtName: '',
                CtGender: 'M',
                CtTEL: '',
                CtEmail: '',
                CtCompany: '',
                CtUnit: '',
                ConsultType: '',
                ConsultContent: '',
            },
        }
    },

    created() {
        this.getConsultTypeLs()
    },

    methods: {
        async getConsultTypeLs() {
            const vm = this
            let params = {
                group: 'p_ConsultType',
            }
            await getParaLs(params)
                .then(res => {
                    // handle success
                    vm.consultTypeLs = res.Items
                })
                .catch(err => {
                    // handle error
                    vm.consultTypeLs = []
                    console.log(err)
                })
        },

        async submitForm() {
            await this.insertContact()
        },

        async insertContact() {
            const vm = this
            const fullscreenLoading = vm.$loading({
                lock: true,
                text: '請稍候，目前正處理評價與回饋...',
                background: 'rgba(255, 255, 255, 0.5)',
            })
            vm.configs.loading = true
            await insertContact(vm.form)
                /* .then(res => {
                    // handle success
                    vm.$message({ type: 'success', message: res.Msg, dangerouslyUseHTMLString: true })
                }) */
                .catch(err => {
                    // handle error
                    console.log(err)
                })
                .finally(() => {
                    // always executed
                    fullscreenLoading.close()
                })
        },
    },
}
</script>

<style scoped lang="scss"></style>
